
export const environment = {
    electron: false,
    production: true,
    routerUsesHash: false,
    gatewayUrl: "https://portal.graphon.com"
};
